import React from 'react';
import { Button, ButtonGroup, CssBaseline, Grid, withStyles } from '@material-ui/core';
import axios from 'axios';
import swal from '@sweetalert/with-react';

import axiosInstance, { EVENT_ID, getUserID, WEB_API } from '../constatns';
import Menu from '../components/Menu';
import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import MyPageHome from './MyPageHome';
import UserInfoTable from './UserInfoTable';
import AbstractTable from './AbstractTable';
import SpeakerTable from './SpeakerTable';
import AbstractReview from './AbstractReview';
import RegistrationPreview from '../registration/RegistrationPreview';

const styles = (theme) => ({});

class MyPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      midx: 6, //MyPage의 Menu index
      // midx: 2, // prs2022 custom 행사 메뉴 추가시 마다 확인 필요
      sidx: 0,
      userInfo: {},
      userInfoMode: 'read',
      lang: 'kor',
      isFree: false,
    };
    this.moveTab = this.moveTab.bind(this);
    this.movePage = this.movePage.bind(this);
  }

  componentDidMount() {
    if (sessionStorage.getItem('_in_user_')) {
      this.getUserInfo();
      if (this.props.location && this.props.location.state) {
        // console.log(this.props.location.state.detail);
        this.setState({ sidx: this.props.location.state.sidx });
      }
    } else {
      this.props.history.push('signin');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.userInfoMode === 'read' && prevState.userInfoMode === 'modify') {
      this.getUserInfo();
    }
  }

  getUserInfo() {
    let buff = {};
    axiosInstance.get(`${WEB_API}/user/info?eventId=${EVENT_ID}&userId=${getUserID()}`).then((res) => {
      // console.log(res.data.Item);
      if (res.data && res.data.Item) {
        if (res.data.Item.isDel === 1) {
          // 관리자에서 삭제한 경우
          sessionStorage.removeItem('_in_user_');
          swal('User does not exist.');
          this.props.history.push('/signin');
          return;
        }
        for (const [key, value] of Object.entries(res.data.Item)) {
          buff[key] = value;
        }
        if (res.data.Item.country.indexOf('Korea') === -1) {
          this.setState({ lang: 'eng' });
        }
        if (res.data.Item.isExtraCharge && !res.data.Item.extraStatus) {
          swal('You have to pay extra charge for registration.').then(() => {
            this.setState({ sidx: 2 });
          });
        }
      }
      this.setState({ userInfo: buff }, () => {
        // console.log(this.state.userInfo);
        if (res.data.Item?.cate1 === 'Invited Speaker') {
          this.setState({ isFree: true });
        } else {
          this.checkIsFree(this.state.userInfo);
        }
      });
      //   console.log(this.state);
    });
  }

  checkIsFree(userInfo) {
    axios.get(`${WEB_API}/user/check?eventId=${EVENT_ID}&username=${userInfo.username}&license=${userInfo.license}`).then((response) => {
      if (response.data && response.data.length > 0) {
        // console.log(response.data[0]);
        if (response.data[0].isFree === 'Y') {
          this.setState({ isFree: true });
        }
      }
    });
  }

  moveTab(idx, _pid, _pinfo, _showType) {
    this.setState({ sidx: idx, pid: _pid, pdata: _pinfo, showType: _showType });
  }

  movePage(link) {
    this.props.history.push(link);
  }

  handleState = (type, value) => {
    this.setState(() => ({ [type]: value }));
  };

  render() {
    const { midx, sidx, userInfo } = this.state;
    // console.log('midx:', midx);
    // console.log('sidx:', sidx);

    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={midx} SIdx={sidx} />
        <Container>
          <Grid container justifyContent={'center'} spacing={4}>
            <Grid item xs={8}>
              <MainTitle>My Page</MainTitle>
            </Grid>
            <Grid item xs={8}>
              <ButtonGroup color="primary" fullWidth disableElevation>
                {Menu[midx].children.map((item, idx) => {
                  if (item.display) {
                    return (
                      <Button
                        key={`btn-group-children-${idx}`}
                        onClick={() => this.moveTab(idx)}
                        variant={sidx === idx ? 'contained' : 'outlined'}
                        disableElevation
                      >
                        {item.label}
                      </Button>
                    );
                  }
                })}
                {userInfo && userInfo.isReviewer && (
                  // <Button onClick={() => this.moveTab(8)} variant={sidx === 8 ? 'contained' : 'outlined'} disableElevation>
                  <Button onClick={() => this.moveTab(6)} variant={sidx === 6 ? 'contained' : 'outlined'} disableElevation>
                    Abstract Review
                  </Button>
                )}
              </ButtonGroup>
            </Grid>
            <Grid item xs={8}>
              {sidx === 0 && (
                <MyPageHome
                  userInfo={this.state.userInfo}
                  lang={this.state.lang}
                  handleState={this.handleState.bind(this)}
                  handleTab={this.moveTab}
                  movePage={this.movePage}
                />
              )}
              {sidx === 1 && (
                <UserInfoTable
                  userInfo={this.state.userInfo}
                  mode={this.state.userInfoMode}
                  lang={this.state.lang}
                  handleState={this.handleState.bind(this)}
                  movePage={this.movePage}
                />
              )}
              {sidx === 4 && (
                <AbstractTable
                  showNewBtn={true}
                  pid={this.state.pid}
                  pdata={this.state.pdata}
                  handleTab={this.moveTab}
                  movePage={this.movePage}
                  showType={this.state.showType}
                />
              )}
              {sidx === 5 && (
                <RegistrationPreview
                  lang={this.state.lang}
                  isMypage={true}
                  userInfo={this.state.userInfo}
                  handleState={this.handleState.bind(this)}
                  movePage={this.movePage}
                  isFree={this.state.isFree}
                />
              )}

              {/* {sidx === 2 && (
                <RegistrationPreview
                  lang={this.state.lang}
                  isMypage={true}
                  userInfo={this.state.userInfo}
                  handleState={this.handleState.bind(this)}
                  movePage={this.movePage}
                  isFree={this.state.isFree}
                />
              )}
              {sidx === 3 && (
                <AbstractTable
                  handleTab={this.moveTab}
                  showNewBtn={true}
                  pid={this.state.pid}
                  pdata={this.state.pdata}
                  movePage={this.movePage}
                  showType={this.state.showType}
                />
              )}
              {sidx === 4 && (
                <SpeakerTable
                  handleTab={this.moveTab}
                  showNewBtn={true}
                  movePage={this.movePage}
                  showType={this.state.showType}
                  pid={this.state.pid}
                  pdata={this.state.pdata}
                />
              )} */}
              {/* 심사위원 only */}
              {/* {sidx === 8 && <AbstractReview />} */}
              {sidx === 6 && <AbstractReview />}
              {sidx === 7 && (
                <SpeakerTable
                  handleTab={this.moveTab}
                  showNewBtn={true}
                  movePage={this.movePage}
                  showType={this.state.showType}
                  pid={this.state.pid}
                  pdata={this.state.pdata}
                />
              )}
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(MyPage);
